import { ref, watch } from "@vue/composition-api";

export type ViewMode = "list" | "chart";

const key = (widget: string) => `cognni.genai.view.${widget}`;

const read = (widget: string): ViewMode => {
  try {
    return window.localStorage.getItem(key(widget)) === "chart" ? "chart" : "list";
  } catch {
    return "list"; // private mode / storage blocked
  }
};

/**
 * A card's list/chart choice, remembered per widget in this browser — the
 * prototype's `useLocalWidgetViewMode`. Lists are the default: they carry the
 * exact counts, and the chart is the optional summary.
 */
export const use_view_mode = (widget: string) => {
  const mode = ref<ViewMode>(read(widget));
  watch(
    mode,
    (value) => {
      try {
        window.localStorage.setItem(key(widget), value);
      } catch {
        // nothing to do — the choice just won't survive a reload
      }
    },
    { lazy: true }
  );
  return mode;
};
